(() => {
  'use strict';
  const boot = () => {
    const root = document.querySelector('.boitoi-publish-theme-host #bt-publish');
    if (!root || root.dataset.themeIntegrationReady === '1') return;
    root.dataset.themeIntegrationReady = '1';

    const grid = root.querySelector('#bt-plan-grid-masterstroke');
    const clearPlanFocus = () => {
      if (!grid) return;
      grid.classList.remove('is-plan-focus');
      grid.querySelectorAll('.bt-plan').forEach((card) => {
        card.classList.remove('is-plan-active');
        card.removeAttribute('aria-current');
      });
    };
    window.addEventListener('scroll', clearPlanFocus, { passive: true });

    const carousel = root.querySelector('[data-author-carousel]');
    if (carousel) {
      root.querySelector('[data-author-prev]')?.addEventListener('click', () => {
        carousel.scrollBy({ left: -Math.max(240, carousel.clientWidth * .75), behavior: 'smooth' });
      });
      root.querySelector('[data-author-next]')?.addEventListener('click', () => {
        carousel.scrollBy({ left: Math.max(240, carousel.clientWidth * .75), behavior: 'smooth' });
      });
    }

    const search = root.querySelector('[data-author-search]');
    const groups = root.querySelector('[data-author-groups]');
    if (search && groups) {
      const links = [...groups.querySelectorAll('[data-author-name]')];
      const groupEls = [...groups.querySelectorAll('[data-author-group]')];
      const note = root.querySelector('[data-author-result-note]');
      const empty = root.querySelector('[data-author-empty]');
      const apply = () => {
        const query = search.value.trim().toLowerCase();
        let shown = 0;
        links.forEach((link) => {
          const visible = !query || link.dataset.authorName.includes(query);
          link.hidden = !visible;
          if (visible) shown += 1;
        });
        groupEls.forEach((group) => {
          group.hidden = ![...group.querySelectorAll('[data-author-name]')].some((link) => !link.hidden);
        });
        if (note) note.textContent = query ? shown + ' matching authors' : 'Showing ' + links.length + ' authors';
        if (empty) empty.hidden = shown !== 0;
      };
      search.addEventListener('input', apply);
      apply();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();